<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{margin: 0;padding: 0;font-family: Helvetica}
*{
  -webkit-touch-callout:none; /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;

  text-size-adjust: 100% !important;
  -webkit-text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;

  
  -webkit-tap-highlight-color: transparent;
}

.modaltxt{
  min-width: 456px;
  height: 130px;
  background: rgba(0,0,0,0.69);
  border-radius: 50px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.modaltxt .mint-toast-text{
  font-size: 28px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue